export function compareOrganizations(inn1: string, kpp1: string | undefined, inn2: string, kpp2: string | undefined): boolean {
    return inn1 == inn2 &&
        ((!kpp1 && !kpp2) || (kpp1 == kpp2));
}

export const AreArraysEqual = (array1: Array<number | string | undefined> | undefined, array2: Array<number | string | undefined> | undefined) => {
    if (!array1 && !array2) {
        return true;
    }

    if (!array1 || !array2) {
        return false;
    }

    if (array1.length === 0 && array2.length === 0) {
        return true;
    }

    if (array1.length !== array2.length) {
        return false;
    }

    for (let i = 0; i < array1.length; i++) {
        if (array2.filter((item2) => item2 === array1[i]).length === 0) {
            return false;
        }
    }

    return true;
}

